export default function getDataQaToDisplay(
  currentPage: number,
  totalMatchedPages: number,
  paginationNumber: number
): string {
  switch (true) {
    case paginationNumber < 0:
      return 'pagination-ellipsis';
    case currentPage === paginationNumber:
      return `active-page-${paginationNumber}`;
    case totalMatchedPages === paginationNumber:
      return `total-pages`;
    default:
      return `page-${paginationNumber}`;
  }
}
